export default __webpack_public_path__ + "static/media/report-cover-page.5131ac58.png";